import React from "react"

import styles from "./stepControl.module.scss"

const StepControl = props =>{
    return (
        <div className={'stepControlWrapper ' + styles.stepControl}>
            {props.children}
        </div>
    )
}

export default StepControl;